import React from "react";
import { useSelector, shallowEqual } from "react-redux";
import {
  fetchConsignmentHistoryAndProducts,
  closeDialog,
  resetReplanningSuccess,
  updateAddressSuccess,
  fetchVTSlotDropdownValues,
  updateCustomerAddress,
} from "./redux/valetTrolleySlice";

import OrderDetails from "../SharedComponent/components/orderDetailComponent";
import {
  createPayloadForUpdatingCustAddress,
} from "mocks/valetTrolley/response.transforms";

import {getAddressInfo, getLatLong} from '../mocks/SharedTransform/response.transforms';
import { pdfjs } from "react-pdf";
import { AppState } from "../config/redux/reducers";
import UACConstants from "../constants/UACConstants";
import ValetTrolleyOrderDetailsEdit from "./ValetTrolleyOrderDetailsEdit";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface ValetTrolleyOrderDetailsProps {
  open: boolean;
  consignment: any;
  isFromViewRoute?: any;
  isEditIcon?: any;
  closePopup: () => void;
}

const ValetTrolleyOrderDetails = (props: ValetTrolleyOrderDetailsProps) => {
  const { open, consignment, isFromViewRoute, isEditIcon, closePopup } = props;

  const {
    consignmentStatuses,
    productsList,
    consignmentDataAfterReplanning,
    updatedCustomerAddress,
    isUpdateAddress,
  } = useSelector((state: AppState) => state.valetTrolley, shallowEqual);


  return (
    <OrderDetails
      open={open}
      consignment={consignment}
      isFromViewRoute={isFromViewRoute}
      isEditIcon={isEditIcon}
      closePopup={closePopup}
      reduxState={{
        consignmentStatuses,  
        productsList,
        consignmentDataAfterReplanning,
        isUpdateAddress,
        updatedCustomerAddress,
      }}
      transform={{
        getAddressInfo, 
        getLatLong,
        createPayloadForUpdatingCustAddress,
      }}
      actions={{
        fetchConsignmentHistoryAndProducts,
        closeDialog,
        resetReplanningSuccess,
        updateAddressSuccess,
        fetchSlotDropdownValues: fetchVTSlotDropdownValues,
        updateCustomerAddress,
      }}
      OrderDetailsEdit={ValetTrolleyOrderDetailsEdit }
      uacKey={UACConstants.VT_ORDERS}
    />
   
  );
};

export default ValetTrolleyOrderDetails;
